import { render, staticRenderFns } from "./FormButtons.vue?vue&type=template&id=3c234f3c&scoped=true&"
import script from "./FormButtons.vue?vue&type=script&lang=js&"
export * from "./FormButtons.vue?vue&type=script&lang=js&"
import style0 from "./FormButtons.vue?vue&type=style&index=0&id=3c234f3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c234f3c",
  null
  
)

export default component.exports